export default "__VITE_ASSET__TNG8ubVF__"